// src/pages/PrivacyPolicyPage.jsx
import React, { useState, useEffect } from "react";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { url } from "../constants/url";
import { useNavigate } from "react-router-dom";

const PrivacyPolicyPage = () => {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${url}/api/public/privacy-policy`)
      .then((res) => {
        setContent(res.data.privacyPolicy.content);
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          localStorage.clear();
          navigate("/login");
        } else {
          console.error(err);
          setError("Failed to load Privacy Policy.");
        }
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    // show a few paragraphs of skeleton
    return (
      <div className="max-w-4xl mx-auto p-6">
        {Array.from({ length: 8 }).map((_, i) => (
          <Skeleton key={i} height={20} style={{ marginBottom: "0.75rem" }} />
        ))}
      </div>
    );
  }

  if (error) {
    return <div className="max-w-4xl mx-auto p-6 text-red-500">{error}</div>;
  }

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white rounded-3xl shadow-md">
      <h1 className="text-3xl font-semibold mb-6 text-[#AF9C80]">
        Boothee’s Privacy Policy
      </h1>
      <div
        className="prose prose-lg text-gray-700"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </div>
  );
};

export default PrivacyPolicyPage;
